export default "__VITE_ASSET__6d2eef0f__"